import {createSlice} from "@reduxjs/toolkit";

export const formSlice = createSlice({
    name: 'casa',
    initialState: {
        form: {
            motivo:'',
            rangoedad: '',
            numerohabitaciones: '',
            rangom2: '',
            tiposuelo: '',
            colorpared: '',
            tipococina: '',
            personalizacionacabados: '',
            banosecundario: '',
            bidet: '',
            opcion_personalizacion: '',
            opcionpersonalizacion_coste: '',
            garaje: '',
            opcion_innovacion: '',
            top3: '',
            rangohipoteca: '',
            comentarios: '',
            nombre: '',
            cp: '',
            email: '',
            telef: '',
            privacidad: false,
            zonainteres: '',
            datalayerid: '',
            campana_fb: '',
            bases: false,
            ID_Social: '',
            tokenXeerpa: '',
            action: ''
        }
    },
    reducers: {
        setFormSlice: (state, action) => {
            state.form = action.payload.form;
        }
    }
})

export const {setFormSlice} = formSlice.actions;

export default formSlice.reducer;
